import { Drawer as MantineDrawer } from "@mantine/core";
import styles from "./drawer.module.scss";
import { CustomDrawerFactory, IProps } from "./drawer.types";
import { componentWrapper } from "../../utilities";
import { DrawerRoot } from "./drawer-root";
import { DrawerTitle } from "./drawer-title";
import { DrawerContent } from "./drawer-content";
import { DrawerCloseButton } from "./drawer-close-button";

/**
 * Drawer component for displaying slide-out side panels.
 * @param {React.ReactNode} props.children - The content to display in the drawer.
 * @returns {JSX.Element} The Drawer component.
 */
const Drawer = componentWrapper<CustomDrawerFactory, IProps>("Drawer", ({ children, ...otherProps }, ref) => {
    return (
        <MantineDrawer
            ref={ref}
            classNames={{
                root: styles["root"],
                overlay: styles["overlay"],
                content: styles["content"],
                body: styles["body"],
                header: styles["header"],
                title: styles["title"],
                close: styles["close"],
                inner: styles["inner"],
            }}
            {...otherProps}
        >
            {children}
        </MantineDrawer>
    );
});

Drawer.Body = MantineDrawer.Body;
Drawer.Root = DrawerRoot;
Drawer.Title = DrawerTitle;
Drawer.Header = MantineDrawer.Header;
Drawer.Content = DrawerContent;
Drawer.Overlay = MantineDrawer.Overlay;
Drawer.CloseButton = DrawerCloseButton;

export { Drawer };
